// DASHBOARD mutations
/* eslint-disable */
import types from '../../types';

export default {
  [types.STORE_CHART]: (state, payload) => {
    if (payload && payload.activity_graph) {
      state.activityGraph = payload.activity_graph;
    }
    if (payload && payload.deviation_graph) {
      state.deviationsGraph = payload.deviation_graph;
    }
    if (payload && payload.performance_graph) {
      state.performanceGraph = payload.performance_graph;
    }
    if (payload && payload.map_graph) {
      state.mapGraph = payload.map_graph;
    }
    if (payload && payload.carrier_graph) {
      state.carrierGraph = payload.carrier_graph;
    }
    if (payload && payload.newest_shipment_graph) {
      state.shipmentsGraph = payload.newest_shipment_graph;
    }
  },
}
